var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66.0871px",
    height: "35.52646px",
    viewBox: "0 0 66.0871 35.52646",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.026001 23.9571C-0.565765 14.2542 9.13945 13.7961 9.13945 13.7961C9.13945 13.7961 8.32162 9.77142 11.2751 8.39645C14.2286 7.02148 16.7911 7.41017 16.7911 7.41017C16.7911 7.41017 17.4353 -0.130112 27.7128 0.00170898C37.9902 0.133545 38.6854 7.41019 38.6854 7.41019C38.6854 7.41019 41.3125 4.26276 45.106 6.5C48.8995 8.73724 46.2842 12.265 46.2842 12.265C46.2842 12.265 65.1358 4.07056 66.0587 20.9247C66.9816 37.7788 45.106 30.7828 45.106 30.7828C45.106 30.7828 40.0018 37.5904 29.0285 34.8952C18.0551 32.1999 16.2123 28.2297 16.2123 28.2297C16.2123 28.2297 0.617767 33.66 0.026001 23.9571Z",
    id: "littleCloud",
    fill: "#E7F5FF",
    fillRule: "evenodd",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02582 28.2246C2.02582 28.2246 12.4515 27.5873 15.0304 18.9316C21.9798 38.3954 39.7407 28.9112 34.7514 21.5605C61.2729 36.2641 60.8547 12.9591 53.9737 10.2539C59.0062 9.59174 67.8867 12.4114 65.7436 25.0207C63.9878 35.3519 50.8991 31.8893 44.9254 30.8876C44.9254 30.8876 42.2404 35.5995 34.466 35.5207C21.703 35.3914 16.1756 28.302 16.1756 28.302C16.1756 28.302 6.34344 31.5783 2.02582 28.2246Z",
    id: "shadowLittleCloud",
    fill: "#D1E6F6",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleCloud);
export default __webpack_public_path__ + "static/media/littleCloud.fb15eab26b4efc9be95ce7f3c698936b.svg";
export { ForwardRef as ReactComponent };